import * as React from 'react';
import styled from 'styled-components';
import { Body2 } from '@estee/elc-typography';
import { observer } from 'mobx-react';

import { classes } from '../../utils/Classes';

interface IVtoShadeInfoLeftContainer {
    displayName?: string;
    subHeader?: string;
}

const Wrapper = styled.div`
    float: left;
    [dir='rtl'] & {
        float: right;
    }
`;

const productClassNames = classes('vto-product-name');
const productSubHeaderClassNames = classes('vto-sub-header');
const shadeInfoLeftContainerClassNames = classes('vto-shade-info-left-container');

export const VtoShadeInfoLeftContainer = observer(
    ({ displayName, subHeader }: IVtoShadeInfoLeftContainer) => (
        <Wrapper className={shadeInfoLeftContainerClassNames}>
            {displayName && (
                <Body2
                    dangerouslySetInnerHTML={{ __html: displayName }}
                    className={productClassNames}
                />
            )}
            {subHeader && (
                <Body2
                    dangerouslySetInnerHTML={{ __html: subHeader }}
                    className={productSubHeaderClassNames}
                />
            )}
        </Wrapper>
    )
);
